import FJUtil from '../../../util/FJUtil';
import $ from 'jquery';
import FJBase from './FJBase';
import FJDomUtil from '../../../util/FJDomUtil';
import FJColorUtil from '../../../util/FJColorUtil';

const __func = (shadowList = []) => {
    return shadowList.map(item => {
        return {
            offset: typeof item.offset != 'undefined' ? item.offset : 10, // 阴影偏移距离，比例值
            angle: typeof item.angle != 'undefined' ? item.angle : 45, // 阴影偏移角度
            blur: typeof item.blur != 'undefined' ? item.blur : 20, // 阴影模糊半径，比例值
            color: (item && item.color) || '#f00000', // 阴影颜色
            opacity: (item && item.opacity) || 100, // 阴影透明度
            position: (item && item.position) || 'relative',
        };
    });
};

class FJShadows extends FJBase {
    constructor(props) {
        super(props);
        props = props || {};
        this._name = 'FJShadows';
        this._shadowList = __func(props.shadowList || []); // 阴影列表

        this._textColor = (props && props.textColor) || ''; // 文字颜色
        this._position = (props && props.position) || 'absolute';
    }

    encode() {
        return {
            name: this._name,
            shadowList: [...this._shadowList],
            textColor: this._textColor,
        };
    }
    decode(data) {
        this._shadowList = data.shadowList ? [...data.shadowList] : [{ ...data }];
        this._textColor = data.textColor;
    }
    clone() {
        let object = new FJShadows();
        object.decode(this);
        return object;
    }

    get shadowList() {
        return [...this._shadowList];
    }

    set shadowList(shadowList) {
        this._shadowList = [...shadowList];
    }

    _getTextShadow(fontSize) {
        return this._shadowList.map(shadow => {
            const ref = (fontSize * shadow.offset) / 100;
            const x = ref * Math.cos((shadow.angle / 180) * Math.PI);
            const y = ref * Math.sin((shadow.angle / 180) * Math.PI);
            const blur = (fontSize * shadow.blur) / 100;
            const rgbaColor = FJColorUtil.hexToRgba(shadow.color, shadow.opacity);
            return x + 'px ' + y + 'px ' + blur + 'px ' + rgbaColor.rgba;
        });
    }

    /**
     * 更新文字某一行文字样式
     * @param styleData
     * @param lineIdx
     */
    updateStyle(styleData, lineIdx) {
        if (!this._layer) return;
        let lineLayers = this.getLineLayers();
        if (lineIdx < lineLayers.length) {
            let ele = lineLayers[lineIdx];
            if (this._textColor) {
                $(ele).css({
                    ...styleData,
                    color: this._textColor,
                });
            } else {
                $(ele).css(styleData);
            }
        }

        const fontSize = parseFloat(styleData.fontSize) * (styleData.contentScale ? styleData.contentScale : 1);
        const textShadowList = this._getTextShadow(fontSize);
        $(this._layer).css({
            textShadow: textShadowList.join(','),
        });
    }

    /**
     * @desc 更新所有行文字文字样式
     * @param styleData
     */
    updateAllLineStyle(styleData) {
        if (!this._layer) return;
        let lineLayers = this.getLineLayers();
        for (let i = 0; i < lineLayers.length; i++) {
            let ele = lineLayers[i];
            if (this._textColor) {
                $(ele).css({
                    ...styleData,
                    color: this._textColor,
                });
                FJDomUtil.updateSpanTextNodeColor(ele, this._textColor);
            } else {
                $(ele).css(styleData);
            }
        }

        const fontSize = parseFloat(styleData.fontSize) * (styleData.contentScale ? styleData.contentScale : 1);
        const textShadowList = this._getTextShadow(fontSize);
        $(this._layer).css({
            textShadow: textShadowList.join(','),
        });
    }

    clear() {
        if (this._layer && this._layer.parentNode) {
            this._layer.parentNode.removeChild(this._layer);
        }
    }
}

export default FJShadows;
